import * as _ from 'lodash';
import countries from '../config/country-codes.json';

export const getCountries = (universities?: University[]): Country[] => {
  const groups = _.groupBy(universities, 'country');
  return Object.keys(groups)
    .map((title) => {
      const matched = countries.find((item) => item.country === title);
      return {
        title,
        latitude: matched?.latitude || 0,
        longitude: matched?.longitude || 1,
        count: groups[title].length,
      };
    })
    .sort((item1, item2) => item1.title.localeCompare(item2.title));
};
